import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import {
    verifyAdminPwd,
    setAdminSession,
    ensureDefaultAdminPwd,
} from "../lib/store";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [pwd, setPwd] = useState("");
    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        ensureDefaultAdminPwd();
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const ok = await verifyAdminPwd(pwd);
            if (ok) {
                setAdminSession(true);
                toast.success("Xoş gəldiniz");
                navigate("/admin/dashboard");
            } else {
                toast.error("Şifrə yanlışdır");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen bg-[#0A1F3D] text-white flex items-center justify-center px-6 relative overflow-hidden"
        >
            <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#14545E]/30 blur-3xl" />
            <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-white/[0.04] blur-3xl" />
            <div className="absolute top-0 left-0 right-0 p-6 flex items-center justify-between z-10">
                <a
                    href="/"
                    className="text-xs tracking-wider text-white/70 hover:text-white ka-link"
                    data-testid="back-to-site"
                >
                    ← Sayta qayıt
                </a>
                <div className="text-xs tracking-wider text-white/70">
                    KA Academy / Admin
                </div>
            </div>
            <motion.form
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                onSubmit={submit}
                data-testid="admin-login-form"
                className="relative w-full max-w-md bg-white text-[#121212] rounded-3xl p-10 space-y-8 shadow-2xl shadow-black/20"
            >
                <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-[#14545E]/10 text-[#14545E] mx-auto">
                    <Lock size={22} />
                </div>
                <div className="text-center space-y-3">
                    <div className="text-xs tracking-wider uppercase text-[#14545E]">
                        Admin Panel
                    </div>
                    <h1 className="font-serif-display text-3xl">Daxil ol</h1>
                    <p className="text-sm text-neutral-500">
                        Sayt məzmununu idarə etmək üçün şifrəni daxil edin.
                    </p>
                </div>

                <div>
                    <label className="block text-xs tracking-wider uppercase text-neutral-500 mb-2">
                        Şifrə
                    </label>
                    <input
                        type="password"
                        value={pwd}
                        onChange={(e) => setPwd(e.target.value)}
                        autoFocus
                        data-testid="admin-password-input"
                        className="w-full bg-[#FAFAFA] border border-neutral-200 focus:border-[#14545E] focus:bg-white rounded-xl px-4 py-3 text-[#0A1F3D] outline-none transition-colors"
                        placeholder="••••••••"
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    data-testid="admin-login-submit"
                    className="w-full group flex items-center justify-center gap-2 bg-[#0A1F3D] hover:bg-[#061632] disabled:opacity-50 text-white py-3.5 rounded-full text-sm transition-colors"
                >
                    {loading ? "Yoxlanılır..." : "Daxil ol"}
                    <ArrowRight
                        size={16}
                        className="transition-transform group-hover:translate-x-1"
                    />
                </button>
            </motion.form>
        </div>
    );
}
